import { useStoreState } from "ezStore";
import { intl } from "LocaleWrapper";
import { useApolloClient } from "@apollo/client";

import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";

import { getMultiValuesField } from "components/utils/Permission";

import { GetContainerTypesBySearchForSelectDocument, GetContainerTypesDocument } from "__generated__/view/containertypes/graphql/containerType.queries.generated";

export type ContainerTypeSelectOption = {
	isoTypeCode: string;
}

const ContainerTypeSelect = ({
	includeTeu = false,
	...rest
}: Omit<SelectProps<Pick<ContainerTypeSelectOption, "isoTypeCode">, false>, "fetchOptions" | "paginated"> & { includeTeu?: boolean }) => {

	const session = useStoreState(state => state.session);
	const client = useApolloClient();

	const containerTypesPluginValues = getMultiValuesField(session, "customContainerTypes");
	const customContainerTypes = containerTypesPluginValues.trim().length > 0 ? containerTypesPluginValues.split(";") : [];

	const fetchOption = async (params: string) => {

		if (!params && customContainerTypes.length > 0) {

			const result = await client.query({
				query: GetContainerTypesBySearchForSelectDocument,
				variables: {
					search: {
						exactIsoTypeCodes: customContainerTypes,
					},
					pagination: {
						size: customContainerTypes.length,
					},
					includeTeu: includeTeu,
				},
			});

			return result.data.containerTypeSearch.content;
		}

		const result = await client.query({
			query: GetContainerTypesDocument,
			variables: {
				type: params,
				includeTeu: includeTeu,
			},
		});

		return result.data.containerTypes;
	};

	return (
		<Select
			fetchOptions={fetchOption}
			placeholder={customContainerTypes.length > 0 ? intl.formatMessage({ id: "SELECT_CONTAINER_TYPE" }) : intl.formatMessage({ id: "TYPE_TO_SEARCH" })}
			getOptionLabel={option => option.isoTypeCode}
			{...rest}
		/>
	);
};

export default ContainerTypeSelect;
